export default __webpack_public_path__ + "static/media/hyzebra.d27fa05a.png";